module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Shift-a788758ae69b6b5579fa45ea48d955f7.svg";